import Swiper from 'swiper/bundle';


let swiper;
let lastScrollTop = 0;
let oTop = $('#header').height() * 2;



const build = () => {

    swiper = new Swiper('.banner .swiper', {
        loop: false,
        speed: 600,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 3000,
        },

    })

    window.addEventListener("scroll", function() { // or window.addEventListener("scroll"....
        var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
        if (st > lastScrollTop) {
            if ($(window).scrollTop() > oTop) {
                $('#header').addClass('hidden');
                $('a.nav-handler').removeClass('active');
                $('#menu').removeClass('active');
            }
        } else {
            if (!$('#header').hasClass('auto-scrolling')) {
                $('#header').removeClass('hidden');
            }

        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);

    $('a.nav-handler').on('click', function(e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $('#menu').toggleClass('active');
    });

    $('.menu-toggle').on('click', function(e) {
        $(this).toggleClass('open');
        $('#full-menu').toggleClass('open');

    })

    $('#menu ul li a').on('click', function(e) {
        //console.log(this);
        if ($('.menu-toggle').hasClass('open')) {
            $('.menu-toggle').toggleClass('open');
            $('#full-menu').toggleClass('open');
        }

    })


    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });


}


export default () => {
    build()
}